// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"402b2c9b","367":"8dee98a9","427":"54f3e037","488":"0c0f4a8e","785":"3576c16d"}[chunkId] + ".chunk.js";
};